import React, { useState, useEffect } from 'react';
import { db } from '../config/firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import './LinkManager.css';

const LinkManager = () => {
  const [links, setLinks] = useState({
    windowsPC: 'https://tinyurl.com/elitpc1',
    androidXC: 'https://tinyurl.com/elitmedia1',
    androidSmarters: 'https://tinyurl.com/elitmedia2',
    playStoreXC: 'https://play.google.com/store/apps/details?id=com.nathnetwork.elitplus',
    playStoreSmarters: 'https://play.google.com/store/apps/details?id=com.elitdigitalone.elitdigitaliptvbox',
    iosApp: 'https://apps.apple.com/us/app/000-player/id1665441224'
  });
  const [appNames, setAppNames] = useState({
    windowsPC: 'Elite++',
    androidXC: 'ELIT XC',
    androidSmarters: 'ELIT Smarters',
    iosApp: '000 Player'
  });
  const [loading, setLoading] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    loadLinks();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadLinks = async () => {
    try {
      const linksDoc = await getDoc(doc(db, 'links', 'download'));
      
      if (linksDoc.exists()) {
        const data = linksDoc.data();
        setLinks({
          windowsPC: data.windowsPC || links.windowsPC,
          androidXC: data.androidXC || links.androidXC,
          androidSmarters: data.androidSmarters || links.androidSmarters,
          playStoreXC: data.playStoreXC || links.playStoreXC,
          playStoreSmarters: data.playStoreSmarters || links.playStoreSmarters,
          iosApp: data.iosApp || links.iosApp
        });
        if (data.appNames) {
          setAppNames(data.appNames);
        }
      }
    } catch (err) {
      console.error('Load links error:', err);
    }
  };

  const handleLinkChange = (key, value) => {
    setLinks(prev => ({ ...prev, [key]: value }));
    setSaved(false);
  };

  const handleAppNameChange = (key, value) => {
    setAppNames(prev => ({ ...prev, [key]: value }));
    setSaved(false);
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      setSaved(false);

      await setDoc(doc(db, 'links', 'download'), {
        ...links,
        appNames,
        updatedAt: new Date().toISOString()
      });

      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
      window.dispatchEvent(new CustomEvent('showToast', { 
        detail: { message: '✅ Linkler başarıyla kaydedildi', type: 'success' } 
      }));
    } catch (err) {
      console.error('Save error:', err);
      window.dispatchEvent(new CustomEvent('showToast', { 
        detail: { message: '❌ Kaydetme hatası: ' + err.message, type: 'error' } 
      }));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="link-manager">
      <div className="manager-header">
        <div>
          <h2>🔗 İndirme Linkleri ve Uygulama İsimleri</h2>
          <p>Tüm indirme linkleri ve uygulama isimlerini buradan yönetin</p>
        </div>
        {saved && <span className="saved-badge">✅ Kaydedildi!</span>}
      </div>

      <div className="links-form">
        {/* Windows PC */}
        <div className="link-section">
          <h3>💻 Windows PC Uygulaması</h3>
          <div className="link-grid">
            <div className="link-group">
              <label>Uygulama Adı</label>
              <input
                type="text"
                value={appNames.windowsPC}
                onChange={(e) => handleAppNameChange('windowsPC', e.target.value)}
                placeholder="Örn: Elite++"
              />
            </div>
            <div className="link-group">
              <label>İndirme Linki</label>
              <input
                type="text"
                value={links.windowsPC}
                onChange={(e) => handleLinkChange('windowsPC', e.target.value)}
                placeholder="https://tinyurl.com/elitpc1"
              />
            </div>
          </div>
        </div>

        {/* Android XC */}
        <div className="link-section">
          <h3>🤖 Android - ELIT XC</h3>
          <div className="link-grid">
            <div className="link-group">
              <label>Uygulama Adı</label>
              <input
                type="text"
                value={appNames.androidXC}
                onChange={(e) => handleAppNameChange('androidXC', e.target.value)}
                placeholder="Örn: ELIT XC"
              />
            </div>
            <div className="link-group">
              <label>Harici İndirme Linki</label>
              <input
                type="text"
                value={links.androidXC}
                onChange={(e) => handleLinkChange('androidXC', e.target.value)}
                placeholder="https://tinyurl.com/elitmedia1"
              />
            </div>
            <div className="link-group">
              <label>Google Play Store Linki</label>
              <input
                type="text"
                value={links.playStoreXC}
                onChange={(e) => handleLinkChange('playStoreXC', e.target.value)}
                placeholder="https://play.google.com/store/apps/details?id=..."
              />
            </div>
          </div>
        </div>

        {/* Android Smarters */}
        <div className="link-section">
          <h3>📱 Android - ELIT Smarters</h3>
          <div className="link-grid">
            <div className="link-group">
              <label>Uygulama Adı</label>
              <input
                type="text"
                value={appNames.androidSmarters}
                onChange={(e) => handleAppNameChange('androidSmarters', e.target.value)}
                placeholder="Örn: ELIT Smarters"
              />
            </div>
            <div className="link-group">
              <label>Harici İndirme Linki</label>
              <input
                type="text"
                value={links.androidSmarters}
                onChange={(e) => handleLinkChange('androidSmarters', e.target.value)}
                placeholder="https://tinyurl.com/elitmedia2"
              />
            </div>
            <div className="link-group">
              <label>Google Play Store Linki</label>
              <input
                type="text"
                value={links.playStoreSmarters}
                onChange={(e) => handleLinkChange('playStoreSmarters', e.target.value)}
                placeholder="https://play.google.com/store/apps/details?id=..."
              />
            </div>
          </div>
        </div>

        {/* iOS App */}
        <div className="link-section">
          <h3>🍎 iOS Uygulaması</h3>
          <div className="link-grid">
            <div className="link-group">
              <label>Uygulama Adı</label>
              <input
                type="text"
                value={appNames.iosApp}
                onChange={(e) => handleAppNameChange('iosApp', e.target.value)}
                placeholder="Örn: 000 Player"
              />
            </div>
            <div className="link-group">
              <label>App Store Linki</label>
              <input
                type="text"
                value={links.iosApp}
                onChange={(e) => handleLinkChange('iosApp', e.target.value)}
                placeholder="https://apps.apple.com/us/app/..."
              />
            </div>
          </div>
        </div>

        <div className="form-actions">
          <button 
            onClick={handleSave} 
            className="btn-save"
            disabled={loading}
          >
            {loading ? '⏳ Kaydediliyor...' : '💾 Tüm Değişiklikleri Kaydet'}
          </button>
        </div>
      </div>

      <div className="info-box">
        <h4>ℹ️ Bilgilendirme</h4>
        <p><strong>Uygulama Adı:</strong> Sitede kullanıcılara gösterilecek uygulama ismidir.</p>
        <p><strong>İndirme Linki:</strong> Kullanıcılar bu linke tıkladığında uygulama indirilir.</p>
        <p><strong>💡 İpucu:</strong> Kısa linkler (tinyurl, bit.ly gibi) kullanmanız önerilir.</p>
      </div>
    </div>
  );
};

export default LinkManager;
